<template>
    <div class="ck-editor">
        <textarea :id="id" :value="ckContent" :config="config"></textarea>
    </div>
</template>

<script>
    /*
     - [Ckeditor](http://ckeditor.com/) >= 4
     - [Vue.js](http://vuejs.org/) >= 2
     */
    let counter = 0;

    function isEmptyConfig(config) {
        for(let k in config) {
            if(k) {
                return false;
            }
        }
        //
        return true;
    }

    export default {
        name: 'swb-ck-editor',
        desc: '富文本编辑器',

        props: {
            id: {
                type: String,
                default: () => `ck-editor-${++counter}`
            },
            imageXtHandler: {
                type: Function,
                default: function () {
                    alert('"imageXtHandler" not implemented !');
                }
            },
            content: {
                type: String,
                default: ''
            },
            inline: {
                type: Boolean,
                default: false
            },
            config: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },

        data() {
            return {
                instanceReady: false,
                ckContent: ''
            }
        },
        watch: {
            content(newVal, oldVal) {
                this.ckContent = newVal || '';
                //
                if(this.instanceReady) {
                    this.instance.setData(this.ckContent, {
                        callback: function () {
                            this.resetDirty();
                        }
                    });
                }
            }
        },
        computed: {
            instance: {
                get() {
                    return CKEDITOR.instances[this.id];
                },
                set(inst) {
                    //just to eliminate warning
                }
            }
        },
        //        beforeUpdate()
        //        {
        //            if(this.ckContent !== this.instance.getData()) {
        //                this.instance.setData(this.ckContent, {
        //                    callback: function () {
        //                        this.resetDirty();
        //                    }
        //                });
        //            }
        //        },
        mounted() {
            if(typeof CKEDITOR === 'undefined') {
                console.error('CKEDITOR is missing (http://ckeditor.com/)')
            }
            else {
                if(this.inline === true) {
                    if(!isEmptyConfig(this.config)) {
                        CKEDITOR.inline(this.id, this.config);
                    }
                    else {
                        CKEDITOR.inline(this.id);
                    }
                }
                else {
                    if(!isEmptyConfig(this.config)) {
                        CKEDITOR.replace(this.id, this.config);
                    }
                    else {
                        CKEDITOR.replace(this.id);
                    }
                }

                //console.log(this.id +" : " + theEditor.id);
                //console.log(this.id +" : " + this.instance.id);
                //
                set_imageXtHandler(this.instance.id, this.imageXtHandler || null);
                //
                this.instance.on('change', () => {
                    let html = this.instance.getData();
                    if(html !== this.ckContent) {
                        this.$emit('change', html);
                        //
                        this.ckContent = html;
                    }
                });
                //
                this.instance.on('instanceReady', () => {
                    this.instanceReady = true;
                    //
                    this.ckContent = this.content || '';
                    this.instance.setData(this.ckContent, {
                        callback: function () {
                            this.resetDirty();
                        }
                    });
                });

            }
        },
        beforeDestroy() {
            if(this.instance) {
                del_imageXtHandler(this.instance.id);
                //
                this.ckContent = '';
                this.instance.focusManager.blur(true);
                this.instance.removeAllListeners();
                this.instance.destroy();
            }
            this.instance = null;
            //
            this.content = null;
            this.config = null;
            this.imageXtHandler = null;
        },
        methods: {
            //调整整个编辑器的大小
            resize(width, height) {
                this.instance.resize(width, height);
            },
            //检查编辑器的变更状态（是否有变更）
            isDirty() {
                return this.instance.checkDirty();
            },
            //重置编辑器的变更状态（常用于刚刚保存后）
            resetDirty() {
                this.instance.resetDirty();
            },
            //在当前选择处插入Html内容
            insertHtml(html = '') {
                this.instance.inserHtml(html);
            },
            //在当前选择处插入Html内容
            insertText(text = '') {
                this.instance.insertText(text);
            },
            //直接内容（html）
            setContent(content = '') {
                this.ckContent = content;
                this.instance.setData(content);
            },
            //获取内容（html）
            getContent() {
                return this.instance.getData();
            },
            getText() {
                return this.instance.document.getBody().getText();
            },
            //清除内容
            clear() {
                this.instance.setData('');
            }
        }
    }
</script>
<style>
    .ck-editor::after {
        content: "";
        display: table;
        clear: both;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/CkEditor.vue